import { XLogo, InstagramLogo, TiktokLogo } from '@phosphor-icons/react';

const SOCIALS = [
  { label: 'Twitter / X', href: 'https://nestra.me/nestra_me', Icon: XLogo },
  {
    label: 'Instagram',
    href: 'https://nestra.me/nestra_me',
    Icon: InstagramLogo,
  },
  { label: 'TikTok', href: 'https://nestra.me/nestra_me', Icon: TiktokLogo },
];

const WORDMARK_WIDTH = 1000;
const WORDMARK_HEIGHT = 270;
const WORDMARK_BEARING = 13;
const WORDMARK_VIEWBOX = `${WORDMARK_BEARING} 0 ${WORDMARK_WIDTH - WORDMARK_BEARING * 2} ${WORDMARK_HEIGHT}`;

function FooterWordmark() {
  return (
    <svg
      className="landing-footer__wordmark"
      viewBox={WORDMARK_VIEWBOX}
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient
          id="landing-footer-wordmark"
          x1="0"
          y1="0"
          x2="0"
          y2="1"
        >
          <stop offset="0%" stopColor="var(--ap-text)" />
          <stop offset="45%" stopColor="var(--ap-text)" />
          <stop offset="100%" stopColor="var(--ap-text)" stopOpacity="0" />
        </linearGradient>
      </defs>
      <text
        x="0"
        y="216"
        textLength={WORDMARK_WIDTH}
        lengthAdjust="spacingAndGlyphs"
        fill="url(#landing-footer-wordmark)"
      >
        NESTRA
      </text>
    </svg>
  );
}

export function LandingFooter() {
  return (
    <footer className="landing-footer">
      <div className="landing-wide">
        <div className="landing-footer__top">
          <div className="landing-footer__brand">
            <span className="landing-footer__mark">NESTRA</span>
            <p className="landing-footer__tagline">
              Your entire creative presence, in one link.
            </p>
            <div className="landing-footer__socials">
              {SOCIALS.map(({ label, href, Icon }) => (
                <a
                  key={label}
                  href={href}
                  className="landing-footer__social"
                  aria-label={label}
                >
                  <Icon size={15} weight="fill" />
                </a>
              ))}
            </div>
          </div>
          <div className="landing-footer__cols">
            <div className="landing-footer__col">
              <span className="landing-footer__col-head">Help</span>
              <a href="/#faq" className="landing-footer__col-link">
                FAQ
              </a>
              <a
                href="/docs/getting-started"
                className="landing-footer__col-link"
              >
                Getting started
              </a>
              <a href="/status" className="landing-footer__col-link">
                Status
              </a>
            </div>
            <div className="landing-footer__col">
              <span className="landing-footer__col-head">Support</span>
              <a
                href="mailto:hello@nestra.me"
                className="landing-footer__col-link"
              >
                Contact us
              </a>
              <a
                href="mailto:hello@nestra.me"
                className="landing-footer__col-link"
              >
                Report a bug
              </a>
            </div>
            <div className="landing-footer__col">
              <span className="landing-footer__col-head">Legal</span>
              <a href="/privacy" className="landing-footer__col-link">
                Privacy
              </a>
              <a href="/terms" className="landing-footer__col-link">
                Terms
              </a>
            </div>
          </div>
        </div>
        <FooterWordmark />
        <div className="landing-footer__bottom">
          <span className="landing-footer__copy">
            © {new Date().getFullYear()} Nestra. All rights reserved.
          </span>
          <span className="landing-footer__made">Built for creatives.</span>
        </div>
      </div>
    </footer>
  );
}
